import { compose } from 'redux';
import ArtistRecommendations from './ArtistRecommendations';
import withArtistRecommendations from '../../containers/apollo/withArtistRecommendations';
import withUserAccount from '../../containers/apollo/withUserAccount';
import withBrowserInfo from '../../containers/redux/withBrowserInfo';
import withAnalytics from '../../containers/redux/withAnalytics';
import { withExperimentContext } from '../../contexts/Experiment';
import { withFeatureToggle } from '../../contexts/FeatureToggle';

const ComposedArtistRecommendations = compose(
  withBrowserInfo,
  withAnalytics,
  withUserAccount,
  withExperimentContext,
  withFeatureToggle,
  withArtistRecommendations
)(ArtistRecommendations);
ComposedArtistRecommendations.displayName = ArtistRecommendations.displayName;
export default ComposedArtistRecommendations;
